import { Link } from "react-router-dom";
import SectionTitle from "@/components/base/SectionTitle";

const features = [
  {
    icon: "ri-folder-open-line",
    title: "分类清晰",
    desc: "新番、剧场版、OVA、经典按类整理，另有热血、治愈、科幻等细分维度，想找什么一眼就能定位。",
  },
  {
    icon: "ri-bar-chart-box-line",
    title: "排行实时更新",
    desc: "综合榜、新番榜、剧场版榜等维度实时滚动，让口碑热度一目了然，追番不再纠结。",
  },
  {
    icon: "ri-eye-line",
    title: "作品资料详尽",
    desc: "每部作品都有完整剧情简介、主创与标签资料，帮你快速判断是否值得入坑。",
  },
];

const testimonials = [
  {
    name: "小屿",
    role: "追番十年的老二次元",
    text: "分类真的很细，剧场版和OVA分得清清楚楚，再也不怕错过喜欢番剧的特别篇了。",
  },
  {
    name: "阿柠",
    role: "入坑一年的新观众",
    text: "首页的热门排行很实用，跟着榜单追基本没踩过雷，推荐给刚想入坑的朋友。",
  },
  {
    name: "KoKu",
    role: "科幻番重度爱好者",
    text: "科幻分类收录得相当专业，从机甲到赛博朋克都有，已经在这里补齐了好几部神作。",
  },
];

export default function Brand() {
  return (
    <section className="border-y border-background-300/40 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <SectionTitle
          eyebrow="关于漫番志"
          title="为什么选择我们"
          desc="我们相信，整理一部好作品本身就是一种热爱。漫番志致力于把追番这件小事，做得更省心、更有温度。"
          moreTo="/about"
        />

        <div className="grid gap-4 md:grid-cols-3">
          {features.map((f) => (
            <div
              key={f.title}
              className="rounded-2xl bg-background-50 p-6 ring-1 ring-background-300/60 transition-all hover:-translate-y-1 hover:ring-primary-500/50"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-gradient-to-br from-primary-500 to-accent-500 text-background-50">
                <i className={`${f.icon} text-xl`} />
              </span>
              <h3 className="mt-4 font-heading text-lg text-foreground-950">{f.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{f.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-6 grid gap-4 md:grid-cols-3">
          {testimonials.map((t) => (
            <figure
              key={t.name}
              className="rounded-2xl bg-background-50 p-6 ring-1 ring-background-300/60"
            >
              <i className="ri-double-quotes-l text-2xl text-secondary-400" />
              <blockquote className="mt-2 text-sm leading-relaxed text-foreground-700">{t.text}</blockquote>
              <figcaption className="mt-4 flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent-500 text-sm font-bold text-background-50">
                  {t.name.charAt(0)}
                </span>
                <div>
                  <p className="text-sm font-bold text-foreground-950">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-4 pb-14 md:px-6 md:pb-20">
        <div className="relative overflow-hidden rounded-3xl px-6 py-12 md:px-12">
          <img
            src="https://readdy.ai/api/search-image?query=Anime%20stars%20and%20neon%20shooting%20comets%20across%20a%20dark%20teal%20night%20sky%20with%20coral%20glow%2C%20dreamy%20cinematic%20banner%20background%2C%20energetic%20youthful%20vibe%2C%20high%20detail%20digital%20art&width=1600&height=600&seq=cta-banner-2026&orientation=landscape"
            alt="漫番志追番行动号召背景"
            className="absolute inset-0 h-full w-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-background-950/90 via-background-950/70 to-background-950/40" />
          <div className="relative max-w-2xl">
            <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">
              本周的热门榜单已经更新
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700">
              无论你是追番多年的老二次元，还是刚刚入坑的新观众，从这里开始，每一部值得追的作品都不再错过。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/ranking"
                className="whitespace-nowrap rounded-full bg-gradient-to-r from-primary-500 to-primary-600 px-6 py-2.5 text-sm font-bold text-background-50 transition-opacity hover:opacity-90"
              >
                查看热门排行
              </Link>
              <Link
                to="/category/new"
                className="whitespace-nowrap rounded-full bg-background-100/80 px-6 py-2.5 text-sm font-bold text-foreground-950 ring-1 ring-background-300/70 transition-colors hover:bg-background-100"
              >
                浏览新番速递
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}